import { render, staticRenderFns } from "./WPHAuthorization.vue?vue&type=template&id=4893c831&scoped=true"
import script from "./WPHAuthorization.vue?vue&type=script&lang=js"
export * from "./WPHAuthorization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4893c831",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4893c831')) {
      api.createRecord('4893c831', component.options)
    } else {
      api.reload('4893c831', component.options)
    }
    module.hot.accept("./WPHAuthorization.vue?vue&type=template&id=4893c831&scoped=true", function () {
      api.rerender('4893c831', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/WPHAuthorization.vue"
export default component.exports